import { render, staticRenderFns } from "./globalSearch.vue?vue&type=template&id=3f518b64&scoped=true&"
import script from "./globalSearch.vue?vue&type=script&lang=js&"
export * from "./globalSearch.vue?vue&type=script&lang=js&"
import style0 from "./globalSearch.vue?vue&type=style&index=0&id=3f518b64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f518b64",
  null
  
)

export default component.exports